import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { ISkeletonProps, Skeleton } from 'native-base';

export const ColoredSkeleton = (props: ISkeletonProps) => (
  <Skeleton {...props} endColor={Color['brand.primary.lightest']} />
);

export const LoadingTable = ({ items = 6, columns = 1, isMobile = false }) => {
  if (isMobile) {
    return (
      <VStack space={Spacing['stack.xxs']} py={Spacing['stack.xxxs']}>
        {Array.from({ length: items }).map((_, n) => (
          <UI.Shadow key={n} testId="shadow" level={1} borderRadius="8px">
            <VStack p={Spacing['inset.xs']} space={Spacing['stack.xxxs']}>
              {Array.from({ length: columns }).map((__, m) => (
                <HStack key={m.toString()} justifyContent="space-between">
                  <ColoredSkeleton w="2/5" h="18px" rounded={'full'} />
                  <ColoredSkeleton w="2/5" h="18px" rounded={'full'} />
                </HStack>
              ))}
            </VStack>
          </UI.Shadow>
        ))}
      </VStack>
    );
  }

  return (
    <VStack space={Spacing['stack.xxs']} py={Spacing['stack.xxxs']}>
      {Array.from({ length: items }).map((_, n) => (
        <UI.Shadow key={n} testId="shadow" level={1} borderRadius="8px">
          <HStack p={Spacing['inset.xs']} justifyContent="space-between">
            {Array.from({ length: columns }).map((__, m) => (
              <ColoredSkeleton
                key={m.toString()}
                w={`${100 / (columns + 1)}%`}
                h="14px"
                rounded={'full'}
              />
            ))}
          </HStack>
        </UI.Shadow>
      ))}
    </VStack>
  );
};
